import React, { useEffect, useMemo, useRef, useState } from 'react';
import MapView from '@arcgis/core/views/MapView';
import Map from '@arcgis/core/Map';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Expand from "@arcgis/core/widgets/Expand.js";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Swipe from '@arcgis/core/widgets/Swipe';
import Legend from '@arcgis/core/widgets/Legend';  // Import Legend Widget
import { setIsBufferWidth, setIsSidebar } from '../store/slice/currentStageSlice';

const MapChangeAnalysis = ({ selectedLayer, onViewReady, isWidth, isScreenSize, isByDefaultActive, locationAi, selectedUlb, ulbCode }) => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const [view, setView] = useState(null);
  const [isDrag, setIsDrag] = useState(false);
  const [tabLocation, setTabLocation] = useState(false);
  const [isLayerListExpanded, setIsLayerListExpanded] = useState(false);
  const currentStageValue = useSelector((state) => state.currentStage.features)
  const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
  const { isBufferWidth, isToolHeight, isSideBar, isYearLeft, isYearRight } = useSelector((state) => state.currentStage);
  const features = bufferData[selectedBuffer] || [];
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
  const { isDistCd, isUlbCd, isWardNo } = useSelector((state) => state.currentStage)
  const [selectedYearLeft, setSelectedYearLeft] = useState("1");
  const [selectedYearRight, setSelectedYearRight] = useState("8");

  let lulcLayer1Ref = useRef(null);
  let lulcLayer2Ref = useRef(null);


  console.log("isYearRight,isYearLeft", isYearRight, isYearLeft)

  // const handleYearChangeLeft = (e) => {
  //   setSelectedYearLeft(e.target.value);
  //   console.log("Selected year value Left:", e.target.value);
  // };

  // const handleYearChangeRight = (e) => {
  //   setSelectedYearRight(e.target.value);
  //   console.log("Selected year value Right:", e.target.value);
  // };


  const popupTemplate = {
    title: "LULC Class: {classname}",
    content: `
      <ul>
        <li><b>Class Name:</b> {classname}</li>
        <li><b>Area (sqkm):</b> {area_sqkm}</li>
      </ul>
    `
  };


  useEffect(() => {
    if (!mapRef.current) return;
    const map = new Map({
      basemap: 'satellite',
    });
    const mapView = new MapView({
      container: mapRef.current,
      map: map,
      center: [78.746567, 23.834030],
      zoom: 6,
    });

    mapView.popupEnabled = true;
    setView(mapView);
    let defExpParts = [];
    if (isDistCd) {
      defExpParts.push(`dist_cd = '${isDistCd}'`);
    }
    if (isUlbCd) {
      defExpParts.push(`ulb_cd = '${isUlbCd}'`);
    }
    if (isWardNo) {
      defExpParts.push(`wardno = '${isWardNo}'`);
    }
    const definitionExpression = defExpParts.join(" AND ");

    mapView.when(() => {
      const existingLulcLayer = map.layers.find(layer =>
        layer.type === "map-image" &&
        layer.url.includes('mp_lulc_change')
      );

      if (existingLulcLayer) {
        map.remove(existingLulcLayer);
      }

      //left layer

      lulcLayer1Ref.current = new MapImageLayer({
        url: 'https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer',
        sublayers: [
          {
            // id: parseInt(selectedYearLeft || "2"),
            id: parseInt(isYearLeft || "2"),
            visible: true,
            definitionExpression,
            popupTemplate
            //definitionExpression: `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}' AND wardno = '${isWardNo}'`,

          },
        ],
      });

      map.add(lulcLayer1Ref.current);

      //right layer
      
      lulcLayer2Ref.current = new MapImageLayer({
        url: 'https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer',
        sublayers: [
          {
            // id: parseInt(selectedYearRight || "7"),
            id: parseInt(isYearRight || "7"),
            visible: true,
            definitionExpression,
            popupTemplate
            // definitionExpression: `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}' AND wardno = '${isWardNo}'`,

          },
        ],
      });

      map.add(lulcLayer2Ref.current);

      mapView.when(() => {
        const swipe = new Swipe({
          view: mapView,
          leadingLayers: [lulcLayer1Ref.current],
          trailingLayers: [lulcLayer2Ref.current],
          position: 50
        });

        mapView.ui.add(swipe);
        setView(mapView);
      });

      // const legend = new Legend({
      //   view: mapView,
      //   layerInfos: [
      //     {
      //       layer: lulcLayer1Ref.current, title: "Bhopal 2023",
      //       title: "Change Detection"
      //     }
      //   ]
      // });
      // mapView.ui.add(legend, "bottom-left");


      // Create the legend widget
      const legend = new Legend({
        view: mapView,
        layerInfos: [
          // { layer: layer1, title: "Bhopal 2018" },
          {
            layer: lulcLayer1Ref.current,
            title: "Change Detection"
          }
        ]
      });

      // Wrap the legend inside an Expand widget
      const legendExpand = new Expand({
        view: mapView,
        content: legend,
        expandIconClass: "esri-icon-layer-list", // Optional: Choose a different icon
        expanded: false // Optional: Set to true if you want it open by default
      });

      // Add the expand widget to the UI
      mapView.ui.add(legendExpand, "bottom-left");


      const homeWidget = new Home({ view: mapView });
      const scaleBar = new ScaleBar({ view: mapView, unit: "metric" });
      const basemapGallery = new BasemapGallery({ view: mapView });
      const layerList = new LayerList({ view: mapView });

      mapView.ui.add(new Expand({ view: mapView, content: layerList, expanded: isLayerListExpanded }), "top-right");
      mapView.ui.add(new Expand({ view: mapView, content: basemapGallery }), "top-left");
      mapView.ui.add(homeWidget, "top-left");
      mapView.ui.add(scaleBar, "bottom-right");

      if (onViewReady) {
        onViewReady(mapView);
      }
    });

    mapView.when(() => {
    })

    return () => {
      if (mapView) {
        mapView.destroy();
      }
    };
  }, [ulbCode]);

  let definitionExpression = "";

  if (isDistCd && isUlbCd && isWardNo) {
    definitionExpression = `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}' AND wardno = '${isWardNo}'`;
  } else if (isDistCd && isUlbCd) {
    definitionExpression = `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}'`;
  } else if (isDistCd) {
    definitionExpression = `dist_cd = '${isDistCd}'`;
  } else {
    definitionExpression = "1=1"; // fallback to show all data or handle differently
  }


  useEffect(() => {
    if (!view || !lulcLayer1Ref.current || !lulcLayer2Ref.current) return;

    const yearIdLeft = parseInt(isYearLeft);
    const yearIdRight = parseInt(isYearRight);

    if (!isNaN(yearIdLeft)) {
      lulcLayer1Ref.current.sublayers = [{
        id: yearIdLeft,
        visible: true,
        popupTemplate,
        // definitionExpression: `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}' AND wardno = '${isWardNo}'`,
        definitionExpression: definitionExpression
      }];
      lulcLayer1Ref.current.refresh();
    }

    if (!isNaN(yearIdRight)) {
      lulcLayer2Ref.current.sublayers = [{
        id: yearIdRight,
        visible: true,
        popupTemplate,
        //definitionExpression: `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}' AND wardno = '${isWardNo}'`,
        definitionExpression: definitionExpression
      }];
      lulcLayer2Ref.current.refresh();
    }

  }, [isYearLeft, isYearRight, isDistCd, isUlbCd, isWardNo, view]);

  useEffect(() => {
    if (!isUlbCd || !isWardNo) return;
    const yearIdLeft = parseInt(isYearLeft);
    const yearIdRight = parseInt(isYearRight);
    const fetchAreaSummary = (layerId, label) => {
      console.log("layerIdlayerId", layerId)
      console.log("", layerId)
      const queryUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer/${layerId}/query`;

      const params = new URLSearchParams({
        where: `ulb_cd='${isUlbCd}' and wardno='${isWardNo}'`,
        groupByFieldsForStatistics: 'classname',
        outStatistics: JSON.stringify([{
          statisticType: 'sum',
          onStatisticField: 'ROUND(area_sqkm,2)',
          outStatisticFieldName: 'sum_area'
        }]),
        f: 'json',
        returnGeometry: 'false'
      });

      console.log("params", params)

      fetch(`${queryUrl}?${params.toString()}`)
        .then(response => response.json())
        .then(data => {
          if (data.features) {
            console.log(`🔍 LULC Summary for ${label} (Layer ID: ${layerId}):`);
            data.features.forEach(feature => {
              console.log(`classname: ${feature.attributes.classname}`);
              console.log(`sum_area: ${feature.attributes.sum_area}`);
            });
          } else {
            console.warn(`No features returned for ${label} summary stats.`);
          }
        })
        .catch(error => {
          console.error(`Error fetching summary stats for ${label}:`, error);
        });
    };

    if (!isNaN(yearIdLeft)) fetchAreaSummary(yearIdLeft, 'Left');
    if (!isNaN(yearIdRight)) fetchAreaSummary(yearIdRight, 'Right');

  }, [isUlbCd, isWardNo, isYearLeft, isYearRight]);



  useEffect(() => {

    const handleResize = () => {
      setIsScreenSize1(window.innerWidth <= 991)
    };

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const calculatedHeight = useMemo(() => {
    const hasFeatureTableData = setFeatureTable?.length > 0;
    if (isWidth && isByDefaultActive) {
      return "calc(100vh - 78px)"; // Adjust height as needed
    }
    if (isScreenSize1) {
      return tabLocation === "/user-chatbot" ? "calc(100vh - 200px)" : "calc(80vh - 78px)";
    }
    if (tabLocation) {
      return "calc(100vh - 78px)";
    }
    if (isDrag) {
      return "0px";
    }
    if (isWidth) {
      return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
    }
    if (isWidth) {
      return "calc(100vh - 78px)"
    }
    if (!isWidth && hasFeatureTableData) {
      return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
    }
    if (!isWidth && hasFeatureTableData && isByDefaultActive) {
      return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
    }
    if (isBufferWidth && isToolHeight) {
      return "calc(100vh - 110px)"
    }
    if (isToolHeight) {
      return "calc(100vh - 108px)"
    }

    return "calc(100vh - 200px)";
  }, [tabLocation, isDrag, isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight]);

  const handleToggleBufferWidth = () => {
    dispatch(setIsBufferWidth(!isBufferWidth));
  };
  const handleToggleBufferLeft = () => {
    dispatch(setIsSidebar(!isSideBar));
  };

  return (
    <div className='position-relative'>
      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: currentStageValue == 3 ? '' : calculatedHeight,
          overflow: "hidden",
        }}
      />

      {currentStageValue === 0 ? "" :
        <div className={isWidth ? "d-none" : 'manage-buffer'} type="button" onClick={handleToggleBufferWidth}>
          <div className={isBufferWidth ? 'not-rotate' : 'is-rotate'}>
            <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
          </div>
        </div>
      }
      {currentStageValue === 0 ? "" :
        <div className={isWidth ? "d-none" : 'manage-buffer-left'} type="button" onClick={handleToggleBufferLeft}
        >
          <div className={isBufferWidth ? 'is-rotate' : 'not-rotate'}>
            <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
          </div>
        </div>
      }

      {/* left-panel */}
      {/* <div style={{ marginTop: "10px" }}>
                <label htmlFor="yearSelect">Left Panel </label>
                <select
                    id="yearSelect"
                    value={selectedYearLeft}
                    onChange={handleYearChangeLeft}
                >
                    <option value="">-- Select year --</option>
                    <option value="1">2017</option>
                    <option value="2">2018</option>
                    <option value="3">2019</option>
                    <option value="4">2020</option>
                    <option value="5">2021</option>
                    <option value="6">2022</option>
                    <option value="7">2023</option>
                    <option value="8">2024</option>
                </select>
            </div> */}

      {/* right panel  */}
      {/* <div style={{ marginBottom: "50px", position: "absolute", right: "200px" }}>
                <label htmlFor="yearSelect">Right Panel</label>
                <select
                    id="yearSelect"
                    value={selectedYearRight}
                    onChange={handleYearChangeRight}
                >
                    <option value="">-- Select year --</option>
                    <option value="1">2017</option>
                    <option value="2">2018</option>
                    <option value="3">2019</option>
                    <option value="4">2020</option>
                    <option value="5">2021</option>
                    <option value="6">2022</option>
                    <option value="7">2023</option>
                    <option value="8">2024</option>
                </select>
            </div> */}
    </div>
  );
};

export default MapChangeAnalysis;